import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ink text-slate-100 flex items-center justify-center p-6">
          <div className="glass border border-line rounded-2xl p-8 max-w-md text-center">
            <p className="font-display text-3xl uppercase text-pink-400">Petit raté</p>
            <p className="mt-3 text-slate-300">
              Une partie du site n'a pas voulu s'afficher. Recharge la page et ça devrait repartir.
            </p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-6 px-6 py-3 rounded-full bg-pink-500 text-ink font-bold"
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
